const choices = {
    inFunding: 'Intégrés dans le financement',
    paidByCustomer: 'Réglés par le client à l\'acte',
};

export default choices;
